import moment from 'moment'
export default {
  className: 'order',
  title: '上门配送',
  render: (record) => {
    return record.orderId
  },
  perPage: 10,
  mixin: {
    fields: [
      {
        name: 'orderId'
      },
      {
        name: 'user',
        note: '用户',
        searchKey: ['phone', 'nickName'],
        render: (record) => {
          if (record && record.user) {
            return `${record.user.nickName}(${record.user.phone})`
          }
        },
        listWhere: (where) => {
          where.isAdmin = {
            $ne: true
          }
        }
      },
      {
        name: 'deliveryAddress',
        note: '送货地址',
        render: (record) => {
          if (record && record.deliveryAddress) {
            return decodeURIComponent(record.deliveryAddress)
          }
        }
      },
      {
        name: 'deliveryTime',
        note: '上门时间',
        render: (record) => {
          if (record && record.deliveryTime) {
            return decodeURIComponent(record.deliveryTime)
          }
        }
      },
      {
        name: 'money',
        note: '应付金额',
        width: 120
      },
      {
        name: 'relMoney',
        note: '实付金额',
        width: 120
      },
      {
        name: 'goodsObj',
        note: '商品信息',
        render: (record) => {
          let string = ''
          if (record.goodsObj) {
            for (let i in record.goodsObj) {
              let item = record.goodsObj[i]
              if (Number(i) === record.goodsObj.length - 1) {
                string += `${item.name}(${item.count})`
              } else {
                string += `${item.name}(${item.count})、`
              }
            }
          }
          return string
        }
      },
      'address',
      'createdAt',
      'updatedAt'
    ],
    search: [
      'orderId',
      'user',
      'address'
    ]
  },
  action: {
    delete: false,
    create: false,
    edit: false,
    export: {
      type: 'list',
      icon: 'export',
      text: '导出',
      component: 'akModelExporter',
      events: {
        exportComplete: () => {} // 导出完成后触发的事件
      }
    }
  },
  hooks: {
    async beforeFetch ({ where }) {
      where.type = 'shopping'
      where.deliveryMode = 'delivery'
      where.state = {
        $nin: ['bePaid', 'refund']
      }
      // moment今日开始时间与今日的结束时间
      let today = moment().startOf('day').toISOString()
      let todayEnd = moment().endOf('day').toISOString()
      where.createdAt = {
        $gte: today,
        $lte: todayEnd
      }
    }
  }
}
